<template>
  <div class="auth-layout row align-content--center">
    <div class="flex xs12 pa-3 flex-center">
      <router-link class="py-5 flex-center title" to="/">
        篱笆教育运营后台
      </router-link>
    </div>
    <div class="flex xs12 pa-3">
      <div class="d-flex justify--center">
        <va-card class="auth-layout__card">
          <va-tabs
            v-model="tabIndex"
            center
          >
            <va-tab>{{ $t('auth.login') }}</va-tab>
          </va-tabs>
          <va-separator/>
          <div class="pa-3">
            <router-view/>
          </div>
        </va-card>
      </div>
    </div>
    <made-by></made-by>
  </div>
</template>

<script>

import MadeBy from '../pages/MadeByComponent'

const tabs = [
  'login',
  'signup',
]

export default {
  name: 'AuthLayout',
  components: {
    MadeBy,
  },
  data () {
    return {
    }
  },
  computed: {
    tabIndex: {
      set (tabIndex) {
        this.$router.push({ name: tabs[tabIndex] })
      },
      get () {
        return tabs.indexOf(this.$route.name)
      },
    },
  },
}
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(45deg, #0081ff, #1cbbb4);

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }

  .title {
    font-size: 36px;
    font-weight: bold;
    font-family: "Microsoft YaHei UI Light", monospace;
  }
}

</style>
